import { render, staticRenderFns } from "./autoRouterparent.vue?vue&type=template&id=37683f6f&scoped=true&"
import script from "./autoRouterparent.vue?vue&type=script&lang=js&"
export * from "./autoRouterparent.vue?vue&type=script&lang=js&"
import style0 from "./autoRouterparent.vue?vue&type=style&index=0&id=37683f6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37683f6f",
  null
  
)

export default component.exports